module.exports = __webpack_public_path__ + "static/img/day-8.abe44be.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/day-8.png
// module id = evJR
// module chunks = 1